// import { fetchCreateJsapiSignature } from '../../../common/fetch/page/eos-marketing'
import { loadScript, removeObjectKeys, getQueryString, seriParam } from './utils'
import Dajax from '@didi/dajax'

// const DiDiBridge = '//static.udache.com/agility-sdk/2.0.3/aio.js'
const fusionUrl = '//es-static.xiaojukeji.com/static/web/home/js/sdk/fusion-1-286cd68b73.0.7.js'
const ESBridge = '//es-static.xiaojukeji.com/static/web/home/js/jimuBridge1-7c6c4ac246.4.1.js'
const WXJsUrl = '//res.wx.qq.com/open/js/jweixin-1.6.0.js'

const appEnvObj = {
  isDidiESApp: window.navigator.userAgent.toLocaleLowerCase().indexOf('didies') > -1,
  isDidiESHmApp: window.navigator.userAgent.toLocaleLowerCase().indexOf('didihmes') > -1,
  isDidiApp: window.navigator.userAgent.toLocaleLowerCase().indexOf('didi.passenger') > -1,
  isWx: window.navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') > -1,
  isWxMiniApp: (
    window.navigator.userAgent.toLocaleLowerCase().indexOf('miniprogram') > -1 && window.navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') > -1
  )
}

// import './jimuBridgeApi'
export { appEnvObj }

window.E = {}
window.Info = {}

const fetchIsVip = ({ token, source }) => {
  console.log(token)
  return Dajax.get('//es.xiaojukeji.com/gaea/company/promotion/isVip', {
    params: {
      source,
      token
    }
  }).then(response => response.json())
  // return Dajax.get('/gaea/company/promotion/isVip', params).then(response => response.json())
}

const fetchGetAuthAndRecharge = window.E.fetchGetAuthAndRecharge = ({ token, source }) => {
  console.log(token)
  return Dajax.get('//es.xiaojukeji.com/gaea/company/promotion/getAuthAndRecharge', {
    params: {
      source,
      token
    }
  }).then(response => response.json())
  // return Dajax.post('/gaea/company/promotion/getAuthAndRecharge', params).then(response => response.json())
}

// const fetchCreateJsapiSignature = ({ url }) => {
//   return Dajax.get('//es.xiaojukeji.com/api/eos/v2/weixin/createJsapiSignature', {
//     params: {
//       url
//     }
//   }).then(response => response.json())
// }

export const checkUserInfo = window.E.checkUserInfo = ({ isNeedCheck, token }) => {
  return new Promise((resolve, reject) => {
    if (isNeedCheck) {
      fetchGetAuthAndRecharge({
        source: 'activity_5',
        token
      }).then((res) => {
        // const { data } = res
        console.log('fetchGetAuthAndRechargeData', res)
        /* this.setState({
            isHomeBtnReady: true,
            isRecharege:data.company_recharge_time != 0 ? true : false,
            isCredit:data.company_credit == 1 ? true : false,
            isPay:data.company_admin && data.company_admin.pay == 1 ? true :false
        }) */
        resolve()
      })
    } else {
      /* this.setState({
          isHomeBtnReady: true
      }) */
      resolve()
    }
  })
}

export const checkIsVip = window.E.checkIsVip = ({ token }) => {
  console.log('token', token)
  return new Promise((resolve, reject) => {
    if (token) {
      return fetchIsVip({
        source: 'activity_5',
        token
      }).then((res) => {
        console.log('res', res)
        const { data } = res
        // sessionStorage.isVip = data.is_vip
        const isVip = data.is_vip === 1
        /* this.setState({
          isVip
        }) */
        resolve({
          isNeedCheck: isVip,
          token
        })
      })
    } else {
      resolve({
        isNeedCheck: false,
        token: false
      })
    }
  })
}

export const mountUserinfo = (userinfoObj) => {
  console.log('userinfoObj', userinfoObj)
  return new Promise((resolve, reject) => {
    try {
      if (userinfoObj) {
        sessionStorage.token = userinfoObj.token
        sessionStorage.phone = userinfoObj.phone
        /* this.setState({
            token: userinfoObj.token,
            phone: userinfoObj.phone
        }) */
        resolve(userinfoObj.token)
      } else {
        resolve()
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const getLoginInfofromApp = window.E.getLoginInfofromApp = () => {
  return new Promise((resolve, reject) => {
    try {
      if (appEnvObj.isDidiApp) {
        console.log('didiapp121212', K, K.getUserInfo())
        K.getUserInfo(({ phone, token, uid }) => {
          console.log(phone, token, uid)
          window.Info.uid = uid
          resolve({
            token,
            phone,
            uid
          })
        }, (res) => {
          console.log('fail')
          console.log(res)
        })
      } else if (appEnvObj.isDidiESApp || appEnvObj.isDidiESHmApp) {
        console.log('esApp')
        // console.log('win.loadSc',window.loadScript)

        loadScript(fusionUrl, () => {
          console.log('fusionUrl', fusionUrl)
          loadScript(ESBridge, () => {
            console.log('ESBridge', ESBridge)
            window.bridgeApi.ready(() => {
              console.log('esApp Ready')
              window.bridgeApi.getUserInfo((data) => {
                console.log('esApp data', data)
                if (typeof data === 'string') {
                  data = JSON.parse(data)
                }
                window.Info.companyId = data.companyId
                window.Info.uid = data.uid
                if (Object.keys(data).length > 0 && data.token && data.phone) {
                  resolve({
                    token: data.token,
                    phone: data.phone
                  })
                } else {
                  resolve(false)
                }
              })
            })
          })
        })
      } else {
        resolve(false)
      }
    } catch (error) {
        reject(error)
    }
  })
}

export const getNowTaskVal = window.E.getNowTaskVal = ({ type, token, startTime, endTime, taskId, form }) => {
  console.log('token', type, token, startTime, endTime, form)
  let urlApi = ''
  const params = {
    startTime,
    endTime
  }
  if (type === 1 || type === 5) {
    urlApi = '//eos-marketing.es.xiaojukeji.com/api/eos/data/activityFulfill/companyGmv'
    Object.assign(params, {
      type: type
    })
  } else if (type === 6 || type === 7 || type === 8 || type === 9) {
    urlApi = '//eos-marketing.es.xiaojukeji.com/api/eos/data/activityFulfill/userGmv'
    Object.assign(params, {
      type: type
    })
  } else if (type === 2) {
    urlApi = '//eos-marketing.es.xiaojukeji.com/api/eos/data/activityFulfill/activateAccount'
  } else if (type === 3) {
    urlApi = '//eos-marketing.es.xiaojukeji.com/api/eos/data/activityFulfill/uploadAccount'
  } else if (type === 12 && taskId) {
    urlApi = '//eos-marketing.es.xiaojukeji.com/eos/rule/task/api/my/xpubTask'
    Object.assign(params, {
      taskId
    })
  } else if (type === 4 || type === 10 || type === 11 || type === 12) {
    const typeTrans = {
      4: 1,
      10: 2,
      11: 3,
      12: 4
    }
    urlApi = '//eos-marketing.es.xiaojukeji.com/api/eos/data/activityFulfill/userOrder'
    console.log('typeTrans[type]', typeTrans[type])
    Object.assign(params, {
      type: typeTrans[type]
    })
  }
  if (token) {
    Object.assign(params, {
      token
    })
    return Dajax.get(urlApi, {
      params: params
    }).then(response => response.json())
  } else if (form === 2) {
    return Dajax.get(urlApi, {
      withCredentials: true,
      params: params
    }).then(response => response.json())
  }
}
export const getHotelList = window.E.getHotelList = (param) => {
  console.log('hotelIds')
  // console.log(wsgsig, window.wsgsig)
  const url = '//esapp.xiaojukeji.com/hotel/hotelSearch'
  const params = {
    order_source: 4,
    datatype: 101,
    timestamp: new Date().getTime(),
    app_version: '10.0',
    token: param.token,
    company_id: param.companyId,
    city_id: param.cityId,
    didi_hotel_ids: param.hotelIds,
    checkin_date: param.startTime,
    checkout_date: param.endTime,
    perday_money_quota: 0,
    travel_type: 1,
    page_size: param.hotelIds.replace('，', ',').split(',').length
  }
  return Dajax.post(url, {
    ...params
  }, {
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
      },
      needEncrypt: true
  }).then(response => response.json())
}
// const HOME_URL = 'https://es.xiaojukeji.com/fewxgrouph5/sale/july/home'
// // const RECOMMEND_URL = 'https://es.xiaojukeji.com/fewxgrouph5/sale/july/recommend'
// const SHARE_TITLE = '嗨~ 使用滴滴企业版，省心当老板。立即开通，领优惠！'
// const SHARE_CONTENT = '限时优惠，最高返3200企业用车抵扣券，省心省力省成本，企业出行，就是这么简单！'
// const SHARE_ICON = 'https://es-static.xiaojukeji.com/static/web/do1_MwITmFQNJnkr19IlCYtG'

const baseShareConfig = {
  // url: 'https://es.xiaojukeji.com/fewxgrouph5/sale/july/recommend?referee=1',

  weixin_appmsg: true,
  weixin_timeline: true,

  qq_appmsg: false,
  qzone: false,

  alipay_appmsg: false,
  alipay_timeline: false,
  ding_talk: false
}

// const DiDiShareConfig = Object.assign({}, baseShareConfig, {
//   url: HOME_URL,
//   title: SHARE_TITLE,
//   content: SHARE_CONTENT,
//   icon: SHARE_ICON
// })

// const WxMessageShareConfig = Object.assign({}, baseShareConfig, {
//   title: SHARE_TITLE,
//   desc: SHARE_CONTENT,
//   link: HOME_URL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//   imgUrl: SHARE_ICON
// })

// const WxTimeLineShareConfig = Object.assign({}, baseShareConfig, {
//   title: SHARE_TITLE, // 分享标题
//   link: HOME_URL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//   imgUrl: SHARE_ICON // 分享图标
// })

export const setShare = () => {
  console.log('setShare')
  return new Promise((resolve, reject) => {
    try {
      console.log(window.__DomData, '111', window.__shareData)
      if (window.__DomData.global.canShare) {
        const deleteKey = ['token', 'pid', 'uid', 'openid', 'xenv', 'company_id', 'scnc', 'es_scp', 'code']
        const paramsObj = getQueryString(window.__shareData.url.split('?')[1] || '')
        const _param = removeObjectKeys(paramsObj, deleteKey)
        const shareUrl = window.__shareData.url.split('?')[0] + '?' + seriParam(_param)
        window.__shareData.url = shareUrl
        if (appEnvObj.isDidiESApp) {
          const EsShareConfig = Object.assign({}, baseShareConfig, {
            share_url: window.__shareData.url,
            share_url_origin: window.__shareData.url,
            share_title: window.__shareData.title,
            share_content: window.__shareData.content,
            share_picture: window.__shareData.icon.indexOf('http:') > -1 ? window.__shareData.icon.replace('http:', 'https:') : window.__shareData.icon,
            share_channel: '1,2'
          })
          // console.log('EsShareConfig', EsShareConfig, window.bridgeApi, window.bridgeApi.updateRightIcon)
          window.bridgeApi.updateRightIcon(1)
          window.bridgeApi.rightNavButtonClicked(function () {
            window.bridgeApi.commonShare(EsShareConfig)
          })
          resolve()
        } else if (appEnvObj.isWxMiniApp) {
          loadScript(WXJsUrl, function () {
            function ready () {
              window.wx.miniProgram.postMessage({
                data: {
                  type: 'share',
                  data: {
                    title: window.__shareData.shareCardContent,
                    url: window.__shareData.url,
                    imageUrl: window.__shareData.shareCardIcon
                  }
                }
              })
              resolve()
            }
            if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
              document.addEventListener('WeixinJSBridgeReady', ready, false)
            } else {
              ready()
            }
          })
        } else {
          console.log('window.__shareData>>>', window.__shareData)
          K.setShare(window.__shareData)
          resolve()
        }
      } else {
        K.setShare(false)
        resolve()
      }
      // if (appEnvObj.isDidiApp) {
      //   console.log(DiDiShareConfig)
      //   K.setShare(DiDiShareConfig)
      //   resolve()
      // } else if (appEnvObj.isWx) {
      //   K.web.loadScript(WXJsUrl, {
      //     type: 'text/javascript'
      //   }, () => {
      //     fetchCreateJsapiSignature({
      //       // ...this.state,
      //       url: encodeURIComponent(window.location.href)
      //       // url: this.state.share_config.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //     }).then((data) => {
      //       console.log('wxshare', data)
      //       window.wx.config({
      //         // 开启调试模式,调用的所有api的返j回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //         // debug: true,
      //         appId: data.data.appId, // 必填，公众号的唯一标识
      //         timestamp: data.data.timestamp, // 必填，生成签名的时间戳
      //         nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
      //         signature: data.data.signature, // 必填，签名
      //         jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
      //       })
      //       window.wx.ready(() => {
      //         // console.log('wxready')
      //         window.wx.updateAppMessageShareData(WxMessageShareConfig)
      //         window.wx.updateTimelineShareData(WxTimeLineShareConfig)
      //       })
      //       resolve()
      //     })
      //   })
      // }
      //  else if (appEnvObj.isDidiESApp) {
      //   console.log('EsShareConfig', EsShareConfig)
      //   window.bridgeApi.updateRightIcon(1)
      //   window.bridgeApi.rightNavButtonClicked(function () {
      //     window.bridgeApi.commonShare(EsShareConfig)
      //   })
      //   resolve()
      // } else if (appEnvObj.isWx) {
      //   window.loadScript(WXJsUrl, () => {
      //     fetchCreateJsapiSignature({
      //       state: {
      //         // ...this.state,
      //         url: encodeURIComponent(window.location.href)
      //         // url: this.state.share_config.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //       },
      //       callback: (data) => {
      //         console.log('wxshare', data)
      //         window.wx.config({
      //           // 开启调试模式,调用的所有api的返j回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //           // debug: true,
      //           appId: data.data.appId, // 必填，公众号的唯一标识
      //           timestamp: data.data.timestamp, // 必填，生成签名的时间戳
      //           nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
      //           signature: data.data.signature, // 必填，签名
      //           jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
      //         })
      //         window.wx.ready(() => {
      //           // console.log('wxready')
      //           window.wx.updateAppMessageShareData(WxMessageShareConfig)
      //           window.wx.updateTimelineShareData(WxTimeLineShareConfig)
      //         })
      //         resolve()
      //       }
      //     })
      //   })
      // } else if (appEnvObj.isWxMiniApp) {
      //   window.loadScript(WXJsUrl, function () {
      //     // web-view下的页面内
      //     // function ready() {
      //     window.wx.miniProgram.postMessage({
      //       data: {
      //         type: 'share',
      //         data: {
      //           title: '限时优惠，最高返3200元券',
      //           url: WxMessageShareConfig.link, // + '{token}&isShare=1',
      //           imageUrl: 'https://es-static.xiaojukeji.com/static/web/do1_XxSg9WbFizdYwi1tbKCA'
      //         }
      //       }
      //     })
      //     resolve()
      //     // }
      //     // if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      //     //     document.addEventListener('WeixinJSBridgeReady', ready, false)
      //     // } else {
      //     //     ready()
      //     // }
      //   })
      // } else {
      //   resolve()
      // }
    } catch (error) {
      reject(error)
    }
  })
}
